<template>
  <div class="n-split-input-button n-input" :class="{ 'has-error': errorMessage }">
    <label :for="inputId" class="n-split-input-button__label" :class="{ 'sr-only': hideLabel }">{{ label }}</label>
    <div class="n-split-input-button__wrapper">
      <slot name="input"></slot>
      <div class="n-split-input-button__btn-wrapper">
        <slot name="button"></slot>
        <template v-if="!$slots.button">
          <n-button :icon="icon" class="n-split-input-button__button" @click="$emit('buttonClick')"> </n-button>
        </template>
      </div>
    </div>
    <span class="help-text" v-html="helpText"></span>
    <span class="error-message">{{ errorMessage }}</span>
  </div>
</template>

<script lang="ts" setup>
import NButton from '../../control/button/button.vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';

defineOptions({
  name: 'n-split-input-button',
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
  },
  errorMessage: {
    type: String,
  },
  helpText: {
    type: String,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
});

const { inputId } = useIdGenerator(props.id, 'n-split-input-button_');
</script>
<style lang="scss" scoped>
@use '../../../styles/accessibility.scss' as *;
@use '../../../styles/colours.scss' as *;
@use '../../../styles/input.scss' as *;

.n-split-input-button {
  &__wrapper {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: stretch;
  }
  input,
  select,
  textarea {
    border-radius: 4px 0 0 4px;
  }

  // This is required to make adjustments to input elements in 'NInput' or 'NSelect'
  :deep(.n-input) {
    flex-grow: 1;
    input,
    select,
    textarea {
      border-radius: 4px 0 0 4px;
    }
    label {
      display: none;
    }
    .error-message {
      display: none; // hide the input's error message since we've got our own.
    }
  }

  &__button,
  button,
  .btn {
    font-size: 1em;
    height: 100%;
    display: flex;
    width: 2.25rem;
    justify-content: center;
    align-items: center;
    border-radius: 0 4px 4px 0;
    background-color: #209cee;
    color: #fff;
    border: none;
    &:hover,
    &:focus {
      color: #fff;
      background: #1496ed;
      box-shadow: none;
    }
  }
  .help-text {
    display: block;
    font-size: 0.75rem;
  }
}
</style>
